;(function($, undefined){

    var rnn = window.rnn;

    function initFollow() {
        $('body').on('click', '[data-follow-key]', followElementClicked);
        rnn.modules.user.get(function(user) {
            if (user.authenticated) {
                fetchStatus();
            }
        });

        // Handle following/saving searches separately, because whatever.
        $('body').on('click', '[data-follow-search-data]', followSearchElementClicked);
    }

    function followSearchElementClicked(event) {
        var $followSearchElement = $(this);
        event.preventDefault();
        rnn.modules.user.get(function(user) {
            if (user.authenticated) {
                followSearch($followSearchElement);
            } else {
                rnn.modules.login.loginDisplay("", "login to Follow");
            }
        });
    }

    function followSearch($followElement) {
        var isButton = $followElement.is('.btn'),
            searchData = $followElement.data().followSearchData,
            following = $followElement.hasClass('saved'),
            url = (following ? rnn.site.follow.unfollowSearchURL : rnn.site.follow.followSearchURL);

        $.ajax({
            url: url,
            type: 'POST',
            data: {'data': searchData},
            beforeSend: function (jqXHR, settings) {
                if (isButton) {
                    rnn.modules.loading.start($followElement);
                }
            },
            success: function (followData) {
                var successful;
                if (isButton) {
                    rnn.modules.loading.stop($followElement);
                }

                if (followData.following) {
                    var followClass = $followElement.attr('class');

                    $('.' + followClass).addClass('saved');
                    $('.' + followClass).html('Unsubscribe from this search');
                    rnn.modules.notifications.success('<strong>Search Saved.</strong> You will receive daily email updates with the latest search results.');
                } else {
                    $('.search-save.saved').each(function() {
                        var $this = $(this);
                        $this.removeClass('saved');

                        if($this.parent().attr('class') === 'results-meta' || $this.parent().hasClass('classifieds-controls-save')){
                            $this.html('<i class="icon8x8-save-searches-plus"></i> Save this search');
                        }else{
                            $this.html('Save this search');
                        }
                    });

                    rnn.modules.notifications.info('<strong>Unsubscribed.</strong> You will no longer receive email updates relating to this search.');
                }
                rnn.modules.savedsearch.initContainers();
            },
            error: function (jqXHR, textStatus, errorThrown) {
                var errorMessage;
                if (isButton) {
                    rnn.modules.loading.stop($followElement);
                }
                if (jqXHR.getResponseHeader('content-type') === 'application/json') {
                    try {
                        errorMessage = $.parseJSON(jqXHR.responseText).error;
                    } catch (error) {
                    }
                }
                rnn.modules.notifications.error(errorMessage || errorThrown || 'There was a problem.');
            }
        });
    }


    function followElementClicked(event) {
        var $followElement = $(this);
        event.preventDefault();
        rnn.modules.user.get(function(user) {
            if (user.authenticated) {
                toggleFollowState($followElement);
            } else {
                rnn.modules.login.loginDisplay("follow topic", "Login to Follow");
            }
        });
    }

    function fetchStatus() {
        /*
         * Fetch the status of all follow buttons on the page
         * in a single AJAX request and then display it.
         */
        var $allFollowElements = $('[data-follow-key]'),
            orderedKeys = _.uniq($allFollowElements.map(function() {
                return $(this).data().followKey;
            }));

        if ($allFollowElements.length > 0) {
            $.ajax({
                url: rnn.site.follow.statusURL,
                data: {'data': orderedKeys},
                traditional: true, //otherwise data[] in get data on server.
                success: function (data) {
                    $.each(orderedKeys, function (index, key) {
                        var following = (data.following.indexOf(index) != -1),
                            followCount = data.counts[index];
                        displayStatus(key, following, followCount, data.message);
                    });
                }
            });
        }
    }

    function displayStatus(key, following, followCount, errors) {
        /*
         * Update all follow buttons on the page which match
         * the specified key to show this new information.
         */
        if (errors.length) {
            $.each(errors, function(index, error) {
                rnn.modules.notifications.error(error);
            });
            return false;
        }

        $('[data-follow-key="' + key + '"]').each(function() {
            var $followElement = $(this),
                $readMore = $followElement.siblings('.read-more'),
                isButton = $followElement.is('.btn') || $followElement.is('button'),
                trackLabel = $followElement.data('track'),
                isImageFollow = $followElement.parents(".follower-button").is('.image-follow'),
                newText,
                trackAction,
                track;

            if (following) {
                $followElement
                    .removeClass('tooltip-alt-primary')
                    .addClass('following tooltip-alt-danger');
                if (isButton) {
                    $followElement
                        .removeClass('button-default-dark-blue')
                        .addClass('button-default-dark');
                }
                if (isImageFollow) {
                    newText = 'Unfollow';
                    $readMore.removeClass('hide');
                } else {
                    newText = $followElement.data('unfollow-text') || 'Unfollow';
                }
                // if the user is currently following the topic, then clicking will result in an unfollow action
                trackAction = {action: 'unfollow'};
            } else {
                $followElement
                    .addClass('tooltip-alt-primary')
                    .removeClass('following tooltip-alt-danger');
                if (isButton) {
                    $followElement
                        .removeClass('button-default-dark')
                        .addClass('button-default-dark-blue');
                }
                newText = $followElement.data('follow-text') || 'Follow';
                $readMore.addClass('hide');
                // if the user is not currently following the topic, then clicking will result in an follow action
                trackAction = {action: 'follow'};
            }

            if (isButton) {
                $track = $.extend(trackLabel, trackAction);
                $followElement
                    .html(newText)
                    .data('track', $track);
            } else {
                //It's a mini!
                //Updates text for use on tooltips on mini's
                $followElement.tooltip('hide');
                $followElement
                    .attr('data-title', newText)
                    .attr('data-original-title', newText);
            }

            if (typeof(followCount) == 'number') {
                if (followCount < 0) {
                    followCount = 0;
                }
                $followElement
                    .closest('.follow-meta')
                    .find('.followers-count')
                    .find('.num')
                    .text(followCount)
                    .end()
                    .find('.text')
                    .text('follower' + (followCount == 1 ? '' : 's'));
            }

        });

        return true;
    }

    function toggleFollowState($followElement) {
        /*
         * Either follow or unfollow the button depending
         * on its current state.
         */
        var isButton = $followElement.is('.btn'),
            key = $followElement.data().followKey,
            following = $followElement.hasClass('following'),
            url = (following ? rnn.site.follow.removeURL : rnn.site.follow.createURL);

        $.ajax({
            url: url,
            type: 'POST',
            data: {'data': key},
            beforeSend: function(jqXHR, settings) {
                if (isButton) {
                    rnn.modules.loading.start($followElement);
                }
            },
            success: function(data) {
                var successful;
                if (isButton) {
                    rnn.modules.loading.stop($followElement, true);
                }
                successful = displayStatus(key, data.following, data.count, data.message);
                if (successful) {
                    if (data.following) {
                        rnn.modules.notifications.success('<b>Thanks!</b> You will receive updates related to this content.');
                    } else {
                        rnn.modules.notifications.info('You will no longer receive updates related to this content.');
                    }
                }
            },
            error: function(jqXHR, textStatus, errorThrown) {
                var errorMessage;
                if (isButton) {
                    rnn.modules.loading.stop($followElement);
                }
                if (jqXHR.getResponseHeader('content-type') === 'application/json') {
                    try {
                        errorMessage = $.parseJSON(jqXHR.responseText).error;
                    } catch (error) {}
                }
                rnn.modules.notifications.error(errorMessage || errorThrown || 'There was a problem.');
            }
        });
    }

    rnn.modules.register("follow",{
        init: initFollow,
        fetchStatus: fetchStatus
    });

})(jQuery);
